import React from 'react';
import CopyContentModal from '../copyContentModal';
import { highlightText } from '../../utils/generic/helper';
import './index.scss';

const HighlightText = ({ value, searchText }) => {
  return (
    <div className="highlight-text-wrapper">
      <CopyContentModal>
        <span
          className="text-container"
          dangerouslySetInnerHTML={{
            __html: highlightText(value, searchText?.trim(), 'highlight-search-text'),
          }}
        ></span>
      </CopyContentModal>
    </div>
  );
};
export default HighlightText;
